import styled, { css } from 'styled-components';
import { curry } from 'ramda';
import { Link } from 'react-router-dom';

import {
  themeColor,
  themeColorWithOpacity,
  themeSize,
  themeZIndex,
  whenThemePropEqualsTrue,
} from '../../../theme/getters';
import { ReactComponent as LogoSVG } from '../../../images/logo.svg';
import { Theme } from '../../../modules/headerBar/themes';
import { fillAbsolute } from '../../../theme/mixins';
import { media } from '../../../theme/media';
import { smallParagraph } from '../../../theme/typography';
import { Icon } from '../icon';

export const basedOnHeaderTheme = curry((styles, { theme }) => styles[theme.headerTheme]);

export const headerTransition = '0.2s ease-in-out 0.2s';

const headerBackgroundCss = css`
  ${fillAbsolute};
  background-color: ${themeColor('white')};
  transition: opacity ${headerTransition};
  ${basedOnHeaderTheme({
    [Theme.LIGHT]: css`
      opacity: 0;
    `,
    [Theme.FILLED]: css`
      opacity: 1;
    `,
  })};
`;

export const Container = styled.header`
  position: fixed;
  display: none;
  ${whenThemePropEqualsTrue('isVisible')(
    () => css`
      display: block;
    `
  )};
  padding: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: ${themeSize('header')}px;
  z-index: ${themeZIndex('header')};
  color: ${themeColor('white')};
  transition: background-color ${headerTransition};

  &:before {
    content: '';
    ${headerBackgroundCss};
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 ${themeSize('contentPadding')}px;
  align-items: center;
  height: 100%;
  width: 100%;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    transition: ${headerTransition};
  }

  ${basedOnHeaderTheme({
    [Theme.LIGHT]: css`
      &:after {
        background-color: ${themeColorWithOpacity('white', 0.5)};
        ${media.tablet`
          width: calc(100% - 2 * ${themeSize('contentPadding')}px);
          transform: translateX(${themeSize('contentPadding')}px);
      `};
      }
    `,
    [Theme.FILLED]: css`
      &:after {
        background-color: ${themeColor('middleGray')};
      }
    `,
  })};
`;

export const LogoImg = styled(LogoSVG)`
  position: relative;
  height: 19px;
  transition: fill ${headerTransition};
  ${basedOnHeaderTheme({
    [Theme.LIGHT]: css`
      fill: ${themeColor('white')};
    `,
    [Theme.FILLED]: css`
      fill: ${themeColor('primary')};
    `,
  })};
  ${whenThemePropEqualsTrue('isHamburgerOpen')(
    () => css`
      fill: ${themeColor('primary')};
    `
  )};
`;

export const LogoLink = styled(Link)`
  position: relative;
  z-index: ${themeZIndex('overContent')};
  font-size: 0;
`;

export const BackLink = styled(Link)`
  position: relative;
  justify-content: space-between;
  align-items: center;
  color: ${themeColor('primary')};
  ${smallParagraph};
  display: inline-flex;
`;

export const ArrowIcon = styled(Icon).attrs(() => ({ size: 32 }))`
  margin-left: 8px;
`;
